import { useState } from "react";
import PageBlockDialog from "../PageBlockDialog";

const useBlockDialog = (onSelect, onSelectTemplate) => {
    const [blockDialog, setBlockDialog] = useState(false);

    const openBlockDialog = () => {
        setBlockDialog(true);
    }

    const closeBlockDialog = () => {
        setBlockDialog(false);
    }

    const renderBlockDialog = (blockType) => (
        <PageBlockDialog
            type={blockType}
            open={blockDialog}
            onClose={closeBlockDialog}
            onSelect={(type) => {
                onSelect(type);
                closeBlockDialog();
            }}
            onSelectTemplate={(template) => {
                onSelectTemplate(template);
                closeBlockDialog();
            }}
        />
    );

    return {
        blockDialog,
        openBlockDialog,
        closeBlockDialog,
        renderBlockDialog
    };
};

export default useBlockDialog;